if(window.navigator.userAgent.indexOf("Chrome-Lighthouse")==-1&&window.navigator.userAgent.indexOf("X11")==-1&&window.navigator.userAgent.indexOf("GTmetrix")==-1){var t=function(){if(!script_loaded){script_loaded=!0;var x=document.getElementsByTagName("script");for(i=0;i<x.length;i++)x[i].getAttribute("data-src")!==null&&(x[i].setAttribute("src",x[i].getAttribute("data-src")),delete x[i].dataset.src);var e=document.getElementsByTagName("link");for(i=0;i<e.length;i++)e[i].getAttribute("data-href")!==null&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);document.dispatchEvent(new CustomEvent("StartKernelLoading")),setTimeout(function(){document.dispatchEvent(new CustomEvent("StartAsyncLoading"))},400)}},loadJSscripts=t,script_loaded=!1;window.addEventListener("scroll",function(x){t()}),window.addEventListener("mousemove",function(){t()}),window.addEventListener("touchstart",function(){t()}),window.addEventListener?window.addEventListener("load",function(){setTimeout(t,500)},!1):window.attachEvent?window.attachEvent("onload",function(){setTimeout(t,500)}):window.onload=t}
//# sourceMappingURL=/s/files/1/1100/5760/t/27/assets/custom.js.map?v=1627497511

/* ==========================================================================
   Fix 1: Prevent VanillaModal releaseNode crash
   Instead of clearing modal content (which destroys pre-rendered filters
   on some mobile devices), patch releaseNode to silently handle null nodes.
   ========================================================================== */
(function() {
  var origOpen = null;
  document.addEventListener('DOMContentLoaded', function() {
    // Wrap VanillaModal.prototype.open to catch releaseNode errors
    if (window.VanillaModal && VanillaModal.prototype) {
      var origProtoOpen = VanillaModal.prototype.open;
      VanillaModal.prototype.open = function() {
        try { return origProtoOpen.apply(this, arguments); }
        catch(e) { /* suppress releaseNode crash */ }
      };
    }
  });
  // Also catch errors globally from modal opens as a safety net
  window.addEventListener('error', function(e) {
    if (e && e.message && e.message.indexOf('appendChild') > -1) {
      e.preventDefault();
    }
  });
})();

/* ==========================================================================
   Fix 2: Filter group accordion toggle (open AND close)
   The theme's _toggleGroup uses event.target (breaks with child elements)
   and the close animation's transitionend never fires inside the modal.
   Fix: intercept clicks on [data-filter-group-trigger] inside the filter
   modal, stop the theme's handler, and toggle via direct DOM manipulation.
   ========================================================================== */
(function() {
  document.addEventListener('click', function(e) {
    var button = e.target.closest('[data-filter-group-trigger]');
    if (!button) return;

    var modal = button.closest('.modal--productgrid-filters');
    if (!modal) return;

    e.stopPropagation();

    var list = button.parentElement.querySelector('[data-accordion-content]');
    if (!list) return;

    var isOpen = list.classList.contains('filter-group-active');

    if (isOpen) {
      list.classList.remove('filter-group-active');
      button.classList.remove('productgrid--sidebar-button-active');
      button.setAttribute('aria-expanded', 'false');
      list.removeAttribute('data-accordion-animation');
      list.setAttribute('data-accordion-state', 'closed');
    } else {
      list.classList.add('filter-group-active');
      button.classList.add('productgrid--sidebar-button-active');
      button.setAttribute('aria-expanded', 'true');
      list.removeAttribute('data-accordion-animation');
      list.setAttribute('data-accordion-state', 'open');
    }
  }, true);
})();

/* ==========================================================================
   Fix 3: Inject "Not sure which plug?" buyers guide link into filter lists
   ========================================================================== */
(function() {
  var buyersGuideHTML = '<li class="collection-filters__filter-list-item collection-filters__buyers-guide-item">' +
    '<a href="https://ev-lectron.com/pages/buyers-guide" class="utils-buyers-guide-link utils-buyers-guide-link--mobile productgrid--utils" target="_blank" rel="noopener">' +
      '<span class="utils-buyers-guide-link__icon" aria-hidden="true">' +
        '<svg class="icon-question-mark" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">' +
          '<path d="M16.5 17.4167C16.5002 16.4084 16.7775 15.4196 17.3018 14.5583C17.826 13.697 18.5768 12.9963 19.4723 12.5329C20.3678 12.0696 21.3735 11.8613 22.3794 11.9308C23.3852 12.0004 24.3527 12.3451 25.1759 12.9273C25.9991 13.5095 26.6464 14.3068 27.0471 15.232C27.4477 16.1573 27.5864 17.1749 27.4478 18.1736C27.3092 19.1723 26.8988 20.1137 26.2613 20.8949C25.6239 21.6761 24.7839 22.2671 23.8333 22.6032C23.2969 22.7928 22.8326 23.1441 22.5042 23.6088C22.1759 24.0734 21.9997 24.6284 22 25.1973V27.0417" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M22.0002 31.405C22.1267 31.405 22.2293 31.5076 22.2293 31.6342C22.2293 31.7607 22.1267 31.8633 22.0002 31.8633C21.8736 31.8633 21.771 31.7607 21.771 31.6342C21.771 31.5076 21.8736 31.405 22.0002 31.405" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M1.375 22C1.375 27.4701 3.54798 32.7161 7.41592 36.5841C11.2839 40.452 16.5299 42.625 22 42.625C27.4701 42.625 32.7161 40.452 36.5841 36.5841C40.452 32.7161 42.625 27.4701 42.625 22C42.625 16.5299 40.452 11.2839 36.5841 7.41592C32.7161 3.54798 27.4701 1.375 22 1.375C16.5299 1.375 11.2839 3.54798 7.41592 7.41592C3.54798 11.2839 1.375 16.5299 1.375 22V22Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>' +
        '</svg>' +
      '</span>' +
      '<span class="utils-buyers-guide-link__text">Not sure which plug?</span>' +
    '</a>' +
  '</li>';

  var lists = document.querySelectorAll('[data-productgrid-filters-content] ul[data-accordion-content]');
  lists.forEach(function(ul) {
    var hasPlugFilter = ul.querySelector('[data-name="filter.p.m.custom.nema_plugs"]');
    if (hasPlugFilter) {
      ul.insertAdjacentHTML('beforeend', buyersGuideHTML);
    }
  });
})();

/* ==========================================================================
   Fix 4: "Apply Filters" — batch filter application in mobile drawer
   Intercept filter clicks so they toggle visually without navigating,
   then apply all selected filters at once when the user taps "Apply Filters".
   Uses document-level delegation so it works even if the modal DOM loads late.
   ========================================================================== */
(function() {
  var btnInjected = false;

  /* --- Count how many filters are currently selected --- */
  function countActiveFilters() {
    var modal = document.querySelector('.modal--productgrid-filters');
    if (!modal) return 0;
    return modal.querySelectorAll('[data-filter-input][data-filter-active]').length;
  }

  /* --- Enable / disable the Apply button based on active filter count --- */
  function refreshApplyButton() {
    var btn = document.querySelector('.filter-apply-btn');
    if (!btn) return;
    var count = countActiveFilters();
    btn.disabled = (count === 0);
    btn.textContent = count > 0 ? 'Apply Filters (' + count + ')' : 'Apply Filters';
  }

  /* --- Update each filter group heading with its active count --- */
  function refreshGroupCounts() {
    var modal = document.querySelector('.modal--productgrid-filters');
    if (!modal) return;
    var groups = modal.querySelectorAll('[data-filter-group]');
    groups.forEach(function(group) {
      var titleEl = group.querySelector('.collection-filters__filter-title');
      if (!titleEl) return;

      // Store original title text once
      if (!titleEl.hasAttribute('data-original-title')) {
        titleEl.setAttribute('data-original-title', titleEl.textContent.trim());
      }
      var originalTitle = titleEl.getAttribute('data-original-title');

      // Count active filters in this group
      var activeInGroup = group.querySelectorAll('[data-filter-input][data-filter-active]').length;

      // Remove old badge if any
      var oldBadge = titleEl.querySelector('.filter-group-count');
      if (oldBadge) oldBadge.remove();

      if (activeInGroup > 0) {
        group.classList.add('collection-filters__filter-group--has-active');
        titleEl.textContent = originalTitle + ' ';
        var badge = document.createElement('span');
        badge.className = 'filter-group-count';
        badge.textContent = '(' + activeInGroup + ')';
        titleEl.appendChild(badge);
      } else {
        group.classList.remove('collection-filters__filter-group--has-active');
        titleEl.textContent = originalTitle;
      }
    });
  }

  /* --- Lazily inject the "Apply Filters" button --- */
  function ensureApplyButton() {
    if (btnInjected) return;
    var filterModal = document.querySelector('.modal--productgrid-filters');
    if (!filterModal) return;
    var filtersContent = filterModal.querySelector('[data-productgrid-filters-content]');
    if (!filtersContent) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'filter-apply-wrapper';
    wrapper.innerHTML = '<button type="button" class="filter-apply-btn" disabled>Apply Filters</button>';
    filtersContent.parentNode.appendChild(wrapper);
    btnInjected = true;

    /* Mark filters that are already active from the URL on page load */
    var activeInputs = filterModal.querySelectorAll('.collection-filters__filter-list-item--active [data-filter-input]');
    activeInputs.forEach(function(input) {
      input.setAttribute('data-filter-active', '');
    });
    refreshApplyButton();
    refreshGroupCounts();
  }

  /* Inject as soon as the modal is in the DOM.
     Use a MutationObserver so we catch it regardless of when the theme renders it. */
  ensureApplyButton();
  if (!btnInjected) {
    var observer = new MutationObserver(function() {
      ensureApplyButton();
      if (btnInjected) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* --- Intercept filter option clicks (capture phase on document) --- */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-filter-input]');
    if (!link) return;

    var modal = link.closest('.modal--productgrid-filters');
    if (!modal) return;

    // Don't intercept "remove filter" tags or "Clear All" — let them navigate
    if (link.closest('.active-filter-group__item-wrapper') || link.classList.contains('active-filter-group__item')) return;
    if (link.classList.contains('filter-item-clear-all') || link.closest('.active-filter-group--remove-all')) return;

    // Skip links without data-name (e.g. "clear" links within filter groups)
    if (!link.getAttribute('data-name')) return;

    e.preventDefault();
    e.stopPropagation();

    // Toggle active state
    var isActive = link.hasAttribute('data-filter-active');

    if (isActive) {
      link.removeAttribute('data-filter-active');
    } else {
      link.setAttribute('data-filter-active', '');
    }

    // Toggle parent <li> active class
    var li = link.closest('.collection-filters__filter-list-item');
    if (li) {
      li.classList.toggle('collection-filters__filter-list-item--active', !isActive);
    }

    // Toggle checkbox SVG animation state (svg + all child paths)
    var animEls = link.querySelectorAll('[data-animation-state]');
    var newState = isActive ? 'unchecked' : 'checked';
    animEls.forEach(function(el) {
      el.setAttribute('data-animation-state', newState);
    });

    refreshApplyButton();
    refreshGroupCounts();
  }, true);

  /* --- "Apply Filters" click handler (document-level) --- */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.filter-apply-btn')) return;

    var filterModal = document.querySelector('.modal--productgrid-filters');
    if (!filterModal) return;

    var params = [];

    // Collect all active filter inputs
    var inputs = filterModal.querySelectorAll('[data-filter-input][data-filter-active]');
    inputs.forEach(function(input) {
      var name = input.getAttribute('data-name');
      var value = input.getAttribute('data-value');
      if (name && value) {
        params.push(encodeURIComponent(name) + '=' + encodeURIComponent(value));
      }
    });

    // Collect price range inputs if filled
    var priceMin = filterModal.querySelector('[name="filter.v.price.gte"]');
    var priceMax = filterModal.querySelector('[name="filter.v.price.lte"]');
    if (priceMin && priceMin.value) {
      params.push('filter.v.price.gte=' + encodeURIComponent(priceMin.value));
    }
    if (priceMax && priceMax.value) {
      params.push('filter.v.price.lte=' + encodeURIComponent(priceMax.value));
    }

    // Preserve existing non-filter params (sort_by, grid_list, view, page, q, etc.)
    var currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach(function(val, key) {
      if (key.indexOf('filter.') !== 0) {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
      }
    });

    window.location.search = params.length ? '?' + params.join('&') : '';
  });
})();

/* ==========================================================================
   Fix 5: Quick View – BazaarVoice reviews: append "Reviews" text & ensure
   stars render when modal opens (BV loads async, may miss pre-rendered nodes)
   ========================================================================== */
(function() {
  function fixBvText(container) {
    var texts = container.querySelectorAll('.bv_numReviews_component_container .bv_text');
    texts.forEach(function(el) {
      var t = el.textContent.trim();
      // "(28)" → "(28 Reviews)"
      if (t && t.indexOf('Reviews') === -1) {
        el.textContent = t.replace(')', ' Reviews)');
      }
    });
  }

  // Override BV's inline styles: fill color + star size
  function fixBvStarFills(container) {
    var els = container.querySelectorAll('.qv-modal__rating [data-bv-show="inline_rating"] path, .qv-modal__rating [data-bv-show="inline_rating"] polygon');
    els.forEach(function(el) {
      el.style.setProperty('fill', '#5ABDBF', 'important');
    });
    // Override inline width/height on SVGs (BV forces 20px)
    var svgs = container.querySelectorAll('.qv-modal__rating [data-bv-show="inline_rating"] svg');
    svgs.forEach(function(svg) {
      svg.style.setProperty('width', '13px', 'important');
      svg.style.setProperty('height', '13px', 'important');
    });
  }

  function triggerBvRender(container) {
    var bvEls = container.querySelectorAll('[data-bv-show="inline_rating"]');
    bvEls.forEach(function(el) {
      // If BV hasn't rendered yet (no .bv_main_container child), try to trigger it
      if (!el.querySelector('.bv_main_container') && window.$BV) {
        try { window.$BV.ui('rr', 'inline_ratings', { productIds: [el.getAttribute('data-bv-product-id')] }); } catch(e) {}
      }
    });
  }

  // Performance: only fix BV for the quick-view modal that is opened.
  // Previously this code scanned all `.qv-modal` nodes on the page (expensive once
  // you pre-render quick-view markup inside every product grid card).
  function setupQuickViewBvFixes() {
    var modalContainer = document.querySelector('[data-modal-container]');
    if (!modalContainer) return;

    var modalFixObserver = null;
    var modalContentFixTimeout = null;
    var lastFixAt = 0;

    function applyFixesForOpenQuickView() {
      // Only run when Quick View is actually open.
      if (!modalContainer.classList.contains('modal--quickshop-full')) return;

      var modalContent = modalContainer.querySelector('[data-modal-content]');
      if (!modalContent) return;

      // Stop any previous observer tied to an old modal content node.
      if (modalFixObserver) modalFixObserver.disconnect();
      modalFixObserver = null;
      if (modalContentFixTimeout) window.clearTimeout(modalContentFixTimeout);
      modalContentFixTimeout = null;

      // Initial pass (handles pre-rendered nodes or already-rendered BV).
      var qvModals = modalContent.querySelectorAll('.qv-modal');
      qvModals.forEach(function(modal) {
        triggerBvRender(modal);
        fixBvText(modal);
        fixBvStarFills(modal);
      });

      // Observe BV async updates only within the quick-view modal content.
      modalFixObserver = new MutationObserver(function() {
        var now = Date.now();
        if (now - lastFixAt < 120) return; // throttle to avoid rapid reflows
        lastFixAt = now;

        var qvModalsNow = modalContent.querySelectorAll('.qv-modal');
        qvModalsNow.forEach(function(modal) {
          fixBvText(modal);
          fixBvStarFills(modal);
        });

        // Disconnect once BV has rendered inside all inline rating blocks.
        var inlineRatings = modalContent.querySelectorAll('[data-bv-show="inline_rating"]');
        if (!inlineRatings.length) return;
        var allRendered = true;
        inlineRatings.forEach(function(el) {
          if (!el.querySelector('.bv_main_container')) allRendered = false;
        });
        if (allRendered) {
          if (modalFixObserver) modalFixObserver.disconnect();
          modalFixObserver = null;
        }
      });

      modalFixObserver.observe(modalContent, { childList: true, subtree: true });

      // Safety: stop observing eventually even if BV doesn't render.
      modalContentFixTimeout = window.setTimeout(function() {
        if (modalFixObserver) modalFixObserver.disconnect();
        modalFixObserver = null;
      }, 3500);
    }

    // Trigger fixes when Quick View opens (class is set in quick-view-liquid.js).
    var openObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (modalContainer.classList.contains('modal--quickshop-full')) {
            applyFixesForOpenQuickView();
          }
        }
      });
    });
    openObserver.observe(modalContainer, { attributes: true, attributeFilter: ['class'] });

    // If the modal is already open (rare), apply immediately.
    if (modalContainer.classList.contains('modal--quickshop-full')) {
      applyFixesForOpenQuickView();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupQuickViewBvFixes);
  } else {
    setupQuickViewBvFixes();
  }
})();

var currentAccordion = null;

function logFaqDebug(message, payload) {
  if (payload !== undefined) {
    console.log('[FAQ accordion]', message, payload);
  } else {
    console.log('[FAQ accordion]', message);
  }
}

function bindFaqAccordions(scope) {
  var root = scope || document;
  var headings = root.querySelectorAll('.accordion-item__button');
  var panels = root.querySelectorAll('.accordion-content');
  logFaqDebug('bind called', {
    scope: root === document ? 'document' : 'section',
    headings: headings.length,
    panels: panels.length
  });
}

function toggleFaqAccordion(button) {
  if (!button) return;
  var content = button.nextElementSibling;
  logFaqDebug('click captured', {
    text: (button.textContent || '').trim().slice(0, 80),
    hasContent: !!content,
    contentClass: content ? content.className : null
  });

  if (!content) return;

  if (currentAccordion && currentAccordion !== button) {
    currentAccordion.classList.remove('is-open');
    var currentContent = currentAccordion.nextElementSibling;
    if (currentContent) currentContent.style.maxHeight = null;
  }

  button.classList.toggle('is-open');

  if (content.style.maxHeight) {
    content.style.maxHeight = null;
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
  }

  currentAccordion = (currentAccordion === button) ? null : button;
  logFaqDebug('toggle applied', {
    isOpen: button.classList.contains('is-open'),
    maxHeight: content.style.maxHeight || null,
    scrollHeight: content.scrollHeight
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    bindFaqAccordions(document);
  });
} else {
  bindFaqAccordions(document);
}

document.addEventListener('shopify:section:load', function(event) {
  bindFaqAccordions(event.target);
});

document.addEventListener('click', function(event) {
  var button = event.target.closest('.accordion-item__button');
  if (!button) return;
  toggleFaqAccordion(button);
});

function bindProductAccordionDebug(scope) {
  var root = scope || document;
  var items = root.querySelectorAll('.product_accordion .accordion .container');
  console.log('[Product accordion] bind called', {
    scope: root === document ? 'document' : 'section',
    items: items.length
  });
}

document.addEventListener('click', function(event) {
  var sectionRoot = event.target.closest('.product_accordion');
  if (!sectionRoot) return;

  var item = event.target.closest('.accordion .container');
  if (!item || !sectionRoot.contains(item)) return;

  item.classList.toggle('active');
  var content = item.querySelector('.content');
  console.log('[Product accordion] click captured', {
    label: ((item.querySelector('.label') || {}).textContent || '').trim().slice(0, 80),
    isOpen: item.classList.contains('active'),
    contentHeight: content ? content.scrollHeight : null
  });
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    bindProductAccordionDebug(document);
  });
} else {
  bindProductAccordionDebug(document);
}

document.addEventListener('shopify:section:load', function(event) {
  bindProductAccordionDebug(event.target);
});



var ur = window.location.href;
if(ur.includes('/collection')){
 document.querySelectorAll('.two-column-description__content p').forEach(function(p) {
  if (p.innerHTML.trim() === '&nbsp;' || p.innerHTML.trim() === '') {
    p.remove();
  }
}); 
}


if(window.innerWidth < 768){
var ur = window.location.href;
if(ur.includes('/product')){
 function applyBvRatingToMobile() {
    const bv = document.querySelector(
      '.bv_avgRating_component_container[itemprop="ratingValue"]'
    );
    if (!bv) return;

    const raw = (bv.getAttribute("content") || bv.textContent || "").trim();
    const numReviews = document.querySelectorAll('[data-bv-show="rating_summary"] .bv_numReviews_component_container meta')[0].getAttribute('content');
    const match = raw.replace(/,/g, "").match(/[\d.]+/);
    if (!match) return;

    const num = Number(match[0]);
    const text = Number.isFinite(num) ? num.toFixed(1) : match[0];
    
    document.querySelectorAll(".mobile-rating").forEach((el) => {
      el.textContent = text + " (" + numReviews + " Reviews)";
    });
  }

  applyBvRatingToMobile();
  setTimeout(function(){ 
 applyBvRatingToMobile();
}, 500);
 setTimeout(function(){ 
 applyBvRatingToMobile();
}, 2000);
 setTimeout(function(){ 
 applyBvRatingToMobile();
}, 3000); 
}

document.addEventListener('DOMContentLoaded', function () {
  const triggerm = document.querySelector('.mobile-product-gallery-summary__rating');
  const targetm = document.querySelector('[data-bv-show="reviews"]');

  if (triggerm && targetm) {
    triggerm.addEventListener('click', function (e) {
      e.preventDefault();

      const headerOffset = 70; // adjust if needed
      const y = targetm.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    });
  }
});
}

